/**
 * Reads the `email` carried on the query string. Kept intentionally loose —
 * Clerk does the authoritative validation on submit; this only guards against
 * pre-filling the field with obvious junk (non-strings, empty, over-long, or
 * missing an `@`).
 */
export function readEmailQuery(value: unknown): string | null {
  if (typeof value !== "string") {
    return null
  }
  const trimmed = value.trim()
  // 254 is the RFC 5321 maximum length of an email address.
  if (trimmed.length === 0 || trimmed.length > 254) {
    return null
  }
  return /^[^\s@]+@[^\s@]+$/.test(trimmed) ? trimmed : null
}
